import { createFileRoute } from "@tanstack/react-router";

import TodosExported from "@/features/todos/todos-exported";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/exported",
)({
  component: PayableExportedPage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableExportedPage() {
  return <TodosExported type="payable" />;
}
